import React, { useEffect, useState } from "react";
import Layout from "../layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";
import axios from "axios";

const LogistikListAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  // States for each field in the logistik data form
  const [asal, setAsal] = useState("");
  const [PolisiKendaraan, setPolisiKendaraan] = useState("");
  const [jenisKendaraan, setjenisKendaraan] = useState("");
  const [kapasitasAngkut, setkapasitasAngkut] = useState("");
  const [msg, setMsg] = useState("");

  const saveLogistik = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    try {
      await axios.post(
        `https://c-greenproject.org:8000/logistikdasar`,
        {
          asal,
          PolisiKendaraan,
          jenisKendaraan,
          kapasitasAngkut: Number(kapasitasAngkut),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      navigate("/data-logistik");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    if (user && user.role !== "admin" && user.role !== "logistik") {
      navigate("/dashboard");
    }
  }, [isError, user, navigate]);

  return (
    <Layout>
      <nav aria-label="breadcrumb pb-0">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="/data-logistik">Data Logistik</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Add Data Logistik
          </li>
        </ol>
      </nav>

      <h2 className="title">
        <strong>Add Data Logistik</strong>
      </h2>
      <div className="card is-shadowless">
        <div className="card-content ps-4 mb-3">
          <div className="content">
            <form onSubmit={saveLogistik}>
              <p className="has-text-centered">{msg}</p>

              <div className="add-logistik">
                <div className="column logistik">
                  <div className="field mb-2">
                    <label className="label">Asal</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        value={asal}
                        onChange={(e) => setAsal(e.target.value)}
                        placeholder="Asal"
                      />
                    </div>
                  </div>

                  <div className="field mb-2">
                    <label className="label">Nomor Polisi Kendaraan</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        value={PolisiKendaraan}
                        onChange={(e) => setPolisiKendaraan(e.target.value)}
                        placeholder="Nomor Polisi Kendaraan"
                      />
                    </div>
                  </div>

                  <div className="field mb-2">
                    <label className="label">Jenis Kendaraan</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        value={jenisKendaraan}
                        onChange={(e) => setjenisKendaraan(e.target.value)}
                        placeholder="Jenis Kendaraan"
                      />
                    </div>
                  </div>

                  <div className="field mb-2">
                    <label className="label">Kapasitas Angkut (kg)</label>
                    <div className="control">
                      <input
                        type="number"
                        className="input"
                        value={kapasitasAngkut}
                        onChange={(e) => setkapasitasAngkut(e.target.value)}
                        placeholder="Kapasitas Angkut"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="field mt-3">
                <div className="control">
                  <button
                    type="submit"
                    className="btn btn-success button-detail"
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LogistikListAdd;
